export default {
    slots: {
        base: 'rounded-md font-manrope font-bold transition-colors duration-300',
        label: 'truncate font-manrope',
        leadingIcon: 'shrink-0',
        trailingIcon: 'shrink-0',
    },
    variants: {
        size: {
            xs: {
                base: 'px-2 py-1 text-xs gap-1',
                leadingIcon: 'size-4',
                trailingIcon: 'size-4',
            },
            sm: {
                base: 'px-2.5 py-2 text-sm gap-1',
                leadingIcon: 'size-4',
                trailingIcon: 'size-4',
            },
            md: {
                base: 'px-3 py-2.5 text-sm gap-1',
                leadingIcon: 'size-5',
                trailingIcon: 'size-5',
            },
            lg: {
                label: 'text-base leading-5',
                base: 'px-4 py-3 gap-1',
                leadingIcon: 'size-5',
                trailingIcon: 'size-5',
            },
            xl: {
                base: 'px-6 py-4 text-base gap-1',
                leadingIcon: 'size-6',
                trailingIcon: 'size-6',
            },
        },
    },
    compoundVariants: [
        {
            color: 'primary',
            variant: 'solid',
            class: 'bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-800',
        },
    ],
    defaultVariants: {
        color: 'primary',
        variant: 'solid',
        size: 'md',
    },
};
